import { create } from 'zustand'

export type KnowledgeTransitionTarget = 'editor' | 'settings'

type KnowledgeNavigationState = {
  isTransitioning: boolean
  target: KnowledgeTransitionTarget | null
  startTransition: (target: KnowledgeTransitionTarget) => void
  completeTransition: () => void
}

export const useKnowledgeNavigationStore = create<KnowledgeNavigationState>(
  (set) => ({
    isTransitioning: false,
    target: null,
    startTransition: (target) => set({ isTransitioning: true, target }),
    completeTransition: () => set({ isTransitioning: false, target: null }),
  }),
)
